import {makeStyles} from 'tss-react/mui';
import {Breakpoints as breakpoints} from 'wobi-web-common';

const useStyles = makeStyles()((theme) => ({
  contents: {
    padding: '0 50px',
    width: '100%',
    [`@media screen and (max-width: ${breakpoints.mobile}px)`]: {
      padding: '0 0 20px',
    },
  },
  hide: {
    display: 'none',
  },
  root: {
    display: 'flex',
  },
  tabs: {
    flex: 'none',
    width: 213,
    '& .MuiTab-root': {
      alignItems: 'flex-start',
      justifyContent: 'flex-end',
    },
  },
}));

export default useStyles;
